export default "__VITE_ASSET__Dg7hsXs1__"